// -------------------------------------------------------
// ga-responsive.js
// Responsive mask scaling for Elementor image widgets
// -------------------------------------------------------
jQuery(document).ready(function ($) {
  /* -------------------------------------------------------------------------
   *  Helper function – logs & updates the mask scaleY and height
   * Formula step = (targetScaleY - 1) / (maxThresholdWidth - targetWidth)
   * ------------------------------------------------------------------------- */
  function updateMaskScaleY(maskSelector, maxThresholdWidth, minThresholdWidth, originalScale, step) {
    const winWidth = $(window).width();

    // Target image – adjust selector if a different mask is used
    // TODO: Verify the selector matches the actual DOM element
    // const $mask = $('.elementor-hidden-tablet.elementor-hidden-mobile.elementor-widget.elementor-widget-image > img');
    const $mask = $(maskSelector);

    console.group(`[ga-responsive] ${new Date().toISOString()} – updateMaskScaleY`);
    console.log('  Window width:', winWidth);
    console.log('  Max Threshold width:', maxThresholdWidth);
    console.log('  Min Threshold width:', minThresholdWidth);
    console.log('  Original mask height:', originalScale);
    console.log('  Scale factor step:', step);
    console.log('  Target mask element count:', $mask.length);

    if ($mask.length === 0) {
      console.warn('  ⚠️ No mask element found. Aborting scale update.');
      console.groupEnd();
      return;
    }

    if (winWidth < maxThresholdWidth && winWidth > minThresholdWidth) {
      const delta = maxThresholdWidth - winWidth;
      const scaleY = originalScale + delta * step;

      // Log all intermediary calculations
      console.log('  Δ (threshold - width):', delta);
      console.log('  Calculated scaleY:', scaleY);
      console.log('  Desired height after scaling:', `${originalScale * scaleY}px`);

      // Apply transform and height
      $mask.css({
        transform: `scaleY(${scaleY})`,
        // height: `${originalHeight * scaleY}px`,
      });

      // Log final CSS values
      console.log('  Applied CSS: transform =', $mask.css('transform'));
      console.log('  Applied CSS: height =', $mask.css('height'));
    }

    console.groupEnd();
  }

  /* -------------------------------------------------------------------------
   *  New function – logs & updates the mask background-position-y
   * Formula stepBg = (targetBgPosY - originalBgPosY) / (maxThresholdWidth - targetWidth)
   * ------------------------------------------------------------------------- */
  function updateMaskBackgroundPositionY(maskSelector, maxThresholdWidth, minThresholdWidth, originalBgPosY, stepBg) {
    const winWidth = $(window).width();
    const $mask = $(maskSelector);

    console.group(`[ga-responsive] ${new Date().toISOString()} – updateMaskBackgroundPositionY`);
    console.log('  Window width:', winWidth);
    console.log('  Max Threshold width:', maxThresholdWidth);
    console.log('  Min Threshold width:', minThresholdWidth);
    console.log('  Original bg-position-y:', originalBgPosY);
    console.log('  Bg-position step:', stepBg);
    console.log('  Target mask element count:', $mask.length);

    if ($mask.length === 0) {
      console.warn('  ⚠️ No mask element found. Aborting bg-position update.');
      console.groupEnd();
      return;
    }

    if (winWidth < maxThresholdWidth && winWidth > minThresholdWidth) {
      const delta = maxThresholdWidth - winWidth;
      const newBgPosY = originalBgPosY + delta * stepBg;

      // Log all intermediary calculations
      console.log('  Δ (threshold - width):', delta);
      console.log('  Calculated bg-position-y:', `${newBgPosY}%`);

      // Apply background-position-y
      $mask.css({
        'background-position-y': `${newBgPosY}%`,
      });

      // Log final CSS values
      console.log('  Applied CSS: background-position-y =', $mask.css('background-position-y'));
    }

    console.groupEnd();
  }

  /* -------------------------------------------------------------------------
  New function – logs & updates font-size based scaling
  ------------------------------------------------------------------------- */
  function updateFontSizeScale(textSelector, maxThresholdWidth, minThresholdWidth, originalFontSize, stepFont) {
    const winWidth = $(window).width();
    const $text = $(textSelector);
    console.group(`[ga-responsive] ${new Date().toISOString()} – updateFontSizeScale`);
    console.log('  Window width:', winWidth);
    console.log('  Max Threshold width:', maxThresholdWidth);
    console.log('  Min Threshold width:', minThresholdWidth);
    console.log('  Original font-size:', originalFontSize);
    console.log('  Font-size step:', stepFont);
    console.log('  Target text element count:', $text.length);

    if ($text.length === 0) {
      console.warn('  ⚠️ No text element found. Aborting font-size update.');
      console.groupEnd();
      return;
    }

    if (winWidth < maxThresholdWidth && winWidth > minThresholdWidth) {
      const delta = maxThresholdWidth - winWidth;
      const newFontSize = originalFontSize * (1 + delta * stepFont);

      // Apply font-size and ellipsis handling
      $text.css({
        'font-size': `${newFontSize}px`,
        'white-space': 'nowrap',
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
      });

      // Log final CSS values
      console.log('  Calculated font-size:', `${newFontSize}px`);
      console.log('  Applied CSS: font-size =', $text.css('font-size'));
      console.log('  Applied CSS: text-overflow =', $text.css('text-overflow'));
    } else {
      // Reset to original
      $text.css({
        'font-size': `${originalFontSize}px`,
      });

      console.log('  Window above threshold – resetting font-size to original.');
      console.log('  Applied CSS: font-size =', $text.css('font-size'));
    }

    console.groupEnd();
  }

  /* -------------------------------------------------------------------------
      New function – logs & updates the height of a selector
      ------------------------------------------------------------------------- */

  function updateSelectorHeight(selector, maxThresholdWidth, minThresholdWidth, originalHeight, stepHeight) {
    const winWidth = $(window).width();
    const $elem = $(selector);
    console.group(`[ga-responsive] ${new Date().toISOString()} – updateSelectorHeight`);
    console.log('  Window width:', winWidth);
    console.log('  Max Threshold width:', maxThresholdWidth);
    console.log('  Min Threshold width:', minThresholdWidth);
    console.log('  Original height:', originalHeight);
    console.log('  Height step:', stepHeight);
    console.log('  Target element count:', $elem.length);

    if ($elem.length === 0) {
      console.warn('  ⚠️ No element found for height update.');
      console.groupEnd();
      return;
    }

    if (winWidth < maxThresholdWidth && winWidth > minThresholdWidth) {
      const delta = maxThresholdWidth - winWidth;
      const newHeight = originalHeight - delta * stepHeight;

      $elem.css({
        height: `${newHeight}px`,
      });
    }
  }
  /* -------------------------------------------------------------------------
   *  Resize listener & initial invocation
   * ------------------------------------------------------------------------- */

  // Define selector constants to reduce duplication
  const HERO_MOBILE_SELECTOR = '.home-hero-image-mobile > img';
  const GALLERY_EVEN_DESKTOP_SELECTOR = '.nos-actus .gallery-even-column-desktop > img';
  const GALLERY_ODD_DESKTOP_SELECTOR = '.nos-actus .gallery-odd-column-desktop > img';
  const GALLERY_EVEN_MOBILE_SELECTOR = '.nos-actus .gallery-even-column-mobile > img';
  const GALLERY_ODD_MOBILE_SELECTOR = '.nos-actus .gallery-odd-column-mobile > img';
  const GALLERY2_EVEN_DESKTOP_SELECTOR = '.qui-sommes-nous .gallery-even-column-desktop > img';
  const GALLERY2_ODD_DESKTOP_SELECTOR = '.qui-sommes-nous .gallery-odd-column-desktop > img';
  const GALLERY2_EVEN_MOBILE_SELECTOR = '.qui-sommes-nous .gallery-even-column-mobile > img';
  const GALLERY2_ODD_MOBILE_SELECTOR = '.qui-sommes-nous .gallery-odd-column-mobile > img';

  const HONNEUR_SECTION_MASK_SELECTOR = '.nos-actus .honneur-section-background-mask';

  $(window).on('resize', function () {
    // Formula: stepHeight = (originalHeight - targetHeight) / (maxThresholdWidth - targetWidth)
    // stepHeight = (775 - 675) / (1025 - 900) = 100 / 125 = 0.8
    updateSelectorHeight(HERO_MOBILE_SELECTOR, 1025, 766, 775, 0.8);
    // stepHeight = (565 - 435) / (766 - 600) = 130 / 166 ≈ 0.783
    updateSelectorHeight(HERO_MOBILE_SELECTOR, 766, 300, 565, 0.783);
    // stepHeight = (555 - 420) / (1392 - 1100) = 135 / 292 ≈ 0.462
    updateSelectorHeight(GALLERY_EVEN_DESKTOP_SELECTOR, 1392, 1025, 555, 0.462);
    // stepHeight = (270 - 203) / (1392 - 1100) = 67 / 292 ≈ 0.229
    updateSelectorHeight(GALLERY_ODD_DESKTOP_SELECTOR, 1392, 1025, 270, 0.229);
    // stepHeight = (356 - 118) / (1024 - 384) = 238 / 640 ≈ 0.371
    updateSelectorHeight(GALLERY_EVEN_MOBILE_SELECTOR, 1024, 384, 356, 0.371);
    // stepHeight = (372 - 126) / (1024 - 384) = 246 / 640 ≈ 0.384
    updateSelectorHeight(GALLERY_ODD_MOBILE_SELECTOR, 1024, 384, 372, 0.384);
    // stepHeight = (716 - 540) / (1440 - 1100) = 176 / 340 ≈ 0.517
    updateSelectorHeight(GALLERY2_EVEN_DESKTOP_SELECTOR, 1440, 1025, 716, 0.517);
    // stepHeight = (350 - 263) / (1392 - 1100) = 87 / 340 ≈ 0.256
    updateSelectorHeight(GALLERY2_ODD_DESKTOP_SELECTOR, 1440, 1025, 350, 0.256);
    // stepHeight = (621 - 231) / (1024 - 384) = 390 / 640 ≈ 0.609
    updateSelectorHeight(GALLERY2_EVEN_MOBILE_SELECTOR, 1024, 384, 621, 0.609);
    // stepHeight = (637 - 225) / (1024 - 384) = 412 / 640 ≈ 0.643
    updateSelectorHeight(GALLERY2_ODD_MOBILE_SELECTOR, 1024, 384, 637, 0.643);
    updateSelectorHeight('.spotlight-video-post-img > img', 1440, 1025, 150, (150 - 110) / (1440 - 1025));
    updateSelectorHeight('.spotlight-video-post-img > img', 1024, 768, 160, 0);
    updateSelectorHeight('.spotlight-video-post-img > img', 767, 384, 280, (280 - 130) / (767 - 384));
    // Formula: step = (1.45 - 1) / (1391 - 1025) = 0.45 / 366 ≈ 0.001
    updateMaskScaleY(HONNEUR_SECTION_MASK_SELECTOR, 1391, 1025, 1, 0.45 / 366);
    // Formula: step = (3.1 - 2.2) / (1024 - 768) = 0.9 / 256 ≈ 0.003
    updateMaskScaleY(HONNEUR_SECTION_MASK_SELECTOR, 1024, 768, 2.2, 0.9 / 256);
    // Formula: step = (8 - 5) / (767 - 430) = 3 / 337 ≈ 0.003
    updateMaskScaleY(HONNEUR_SECTION_MASK_SELECTOR, 767, 384, 4.6, 3 / 337);
    // updateMaskBackgroundPositionY(HONNEUR_SECTION_MASK_SELECTOR, 1391, 1025, 0, 55 / 366);
    // Formula: stepBg = (55% - 0%) / (1391 - 1025) = 55 / 366 ≈ 0.120
    updateMaskBackgroundPositionY(HONNEUR_SECTION_MASK_SELECTOR, 1369, 1025, 50, 0);
    // Formula: stepBg = (50% - 0%) / (1024 - 300) = 50 / 724 ≈ 0.120
    updateMaskBackgroundPositionY(HONNEUR_SECTION_MASK_SELECTOR, 1024, 768, 50, 0);
    updateMaskBackgroundPositionY(HONNEUR_SECTION_MASK_SELECTOR, 767, 384, 50.1, 0);
  });
  // Initial call to ensure proper state on page load
  updateSelectorHeight(HERO_MOBILE_SELECTOR, 1025, 766, 775, 0.8);
  updateSelectorHeight(HERO_MOBILE_SELECTOR, 766, 300, 565, 0.783);
  updateSelectorHeight(GALLERY_EVEN_DESKTOP_SELECTOR, 1392, 1025, 555, 0.462);
  updateSelectorHeight(GALLERY_ODD_DESKTOP_SELECTOR, 1392, 1025, 270, 0.229);
  updateSelectorHeight(GALLERY_EVEN_MOBILE_SELECTOR, 1024, 384, 356, 0.371);
  updateSelectorHeight(GALLERY_ODD_MOBILE_SELECTOR, 1024, 384, 372, 0.384);
  updateSelectorHeight(GALLERY2_EVEN_DESKTOP_SELECTOR, 1440, 1025, 716, 0.517);
  updateSelectorHeight(GALLERY2_ODD_DESKTOP_SELECTOR, 1440, 1025, 350, 0.256);
  updateSelectorHeight(GALLERY2_EVEN_MOBILE_SELECTOR, 1024, 384, 621, 0.609);
  updateSelectorHeight(GALLERY2_ODD_MOBILE_SELECTOR, 1024, 384, 637, 0.643);
  updateSelectorHeight('.spotlight-video-post-img > img', 1440, 1025, 150, (150 - 110) / (1440 - 1025));
  updateSelectorHeight('.spotlight-video-post-img > img', 1024, 768, 160, 0);
  updateSelectorHeight('.spotlight-video-post-img > img', 767, 384, 280, (280 - 130) / (767 - 384));
  updateMaskScaleY(HONNEUR_SECTION_MASK_SELECTOR, 1391, 1025, 1, 0.45 / 366);
  updateMaskScaleY(HONNEUR_SECTION_MASK_SELECTOR, 1024, 768, 2.2, 0.9 / 256);
  updateMaskScaleY(HONNEUR_SECTION_MASK_SELECTOR, 767, 384, 4.6, 3 / 337);
  updateMaskBackgroundPositionY(HONNEUR_SECTION_MASK_SELECTOR, 1369, 1025, 50, 0);
  updateMaskBackgroundPositionY(HONNEUR_SECTION_MASK_SELECTOR, 1024, 768, 50, 0);
  updateMaskBackgroundPositionY(HONNEUR_SECTION_MASK_SELECTOR, 767, 384, 50.1, 0);
});
